module.exports = __webpack_public_path__ + "static/media/pokedex_bottom.96dd5054.png";